<template>
  <div class="login-panel-wrapper bord">
    <div class="login-panel-form">
      <h5>{{ systemTitle }}后台</h5>
      <el-form ref="loginForm" :model="loginForm" label-width="0">
        <el-form-item>
          <el-input class="login-input" placeholder="用户名" v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="login-input" placeholder="密码" type="password" v-model="loginForm.password"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; justify-content: space-between;">
            <el-input class="login-input" placeholder="验证码" v-model="loginForm.captcha" style="flex: 1; margin-right: 10px;"></el-input>
            <img :src="captchaSrc" @click="fetchCaptcha" style="cursor: pointer; width: 100px; height: 40px;" alt="验证码"/>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="login-button" type="primary" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ElMessage, ElLoading } from 'element-plus';
import axios from 'axios';

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: '',
      },
      captchaSrc: '',
      systemTitle: '', // 存储系统标题
      logoSrc: '', // Logo图片的URL
    };
  },
  methods: {
    async fetchCaptcha() {
      try {
        const response = await axios.get('/api/captcha', { responseType: 'json' });
        if (response.data && response.data.captcha) {
          this.captchaSrc = 'data:image/jpeg;base64,' + response.data.captcha;
        } else {
          console.error('未能获取到验证码');
          ElMessage({
            type: 'error',
            message: '未能获取到验证码，请重试',
          });
        }
      } catch (error) {
        console.error('Error fetching captcha:', error);
        ElMessage({
          type: 'error',
          message: '获取验证码失败，请重试',
        });
      }
    },
    async fetchSystemTitle() {
      try {
        const response = await axios.get('/api/system-title');
        this.systemTitle = response.data.title;
        document.title = this.systemTitle; // 设置浏览器标签标题
      } catch (error) {
        console.error('Error fetching system title:', error);
        ElMessage({
          type: 'error',
          message: '获取系统标题失败',
        });
      }
    },
    async fetchLogo() {
      try {
        const response = await axios.get('/api/logo', { responseType: 'blob' });
        const logoUrl = URL.createObjectURL(response.data);
        this.logoSrc = logoUrl;
        this.updateFavicon(logoUrl); // 更新favicon
      } catch (error) {
        console.error('Error fetching logo:', error);
      }
    },
    updateFavicon(logoUrl) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = logoUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
    async login() {
      try {
        const captchaResponse = await axios.post('/api/verify_captcha', { captcha: this.loginForm.captcha }, { withCredentials: true });
        if (captchaResponse.data.message !== '验证码正确') {
          ElMessage({
            type: 'error',
            message: '验证码错误',
          });
          this.fetchCaptcha(); // 刷新验证码
          return;
        }

        const response = await axios.post('/api/login', this.loginForm, { withCredentials: true });
        if (response.status === 200) {
          ElMessage({
            type: 'success',
            message: '登录成功',
          });
          this.$router.push('/');
          sessionStorage.setItem('loginInfo', this.loginForm.username);
        }
      } catch (error) {
        console.error('Error:', error);
        ElMessage({
          type: 'error',
          message: error.response.data.message || '登录失败',
        });
        this.fetchCaptcha(); // 刷新验证码
      }
    }
  },
  mounted() {
    let loadingInstance = ElLoading.service({ fullscreen: true, text: '正在获取数据中...' });
    Promise.all([this.fetchCaptcha(), this.fetchSystemTitle(), this.fetchLogo()]).then(() => {
      loadingInstance.close(); // 所有数据加载完毕，关闭加载动画
    }).catch(() => {
      loadingInstance.close(); // 如果有请求失败，也关闭加载动画
    });
  }
};
</script>

<style scoped>
.login-panel-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-panel-form {
  width: 450px;
  padding: 30px;
  border-radius: 10px;
  background-color: #f0f0f0;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
}

.login-panel-form h5 {
  text-align: center;
  margin-bottom: 30px;
}

.login-input {
  width: 100%;
  border: none;
  border-radius: 5px;
  background-color: #eaeaea;
  margin-bottom: 10px; /* 确保验证码输入框和图片之间有适当的间距 */
}

.login-button {
  width: 100%;
  border: none;
  border-radius: 5px;
  background-color: #5a8dee;
}

.bord {
    background: url('https://cdn.pixabay.com/photo/2018/08/14/13/23/ocean-3605547_1280.jpg') no-repeat;
    background-size: 100% 130%;
}
</style>